import { FC, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { useDropOffLocationContext } from '../../../core/application/contexts'
import WasteType from '../../../core/domain/models/WasteType'
import LeftArrowIcon from '../../icons/LeftArrowIcon'
import Button from '../../shared/Buttton'
import WasteTypeGrid from './WasteTypeGrid'

interface DropOffFilterProps {
  wasteTypes: WasteType[]
  onValidate: () => void
  onCancel: () => void
}

const WasteTypeFilterModal: FC<DropOffFilterProps> = (props) => {
  const { wasteTypes, onValidate: validate, onCancel } = props
  const { setWasteTypeFilters, wasteTypeFilters } = useDropOffLocationContext()

  const [selectedWasteTypes, setSelectedWasteTypes] = useState<Array<string>>(wasteTypeFilters)

  const onSelectAll = () => {
    setSelectedWasteTypes(wasteTypes.map((waste) => waste.id))
  }

  const onUnselectAll = () => {
    setSelectedWasteTypes([])
  }

  const onValidate = () => {
    setWasteTypeFilters(selectedWasteTypes)
    validate()
  }

  const onSelect = (id: string) => {
    if (selectedWasteTypes.includes(id)) {
      setSelectedWasteTypes(selectedWasteTypes.filter((wasteTypes) => wasteTypes !== id))
    } else {
      setSelectedWasteTypes((wasteTypes) => [...wasteTypes, id])
    }
  }

  return (
    <Container>
      <HeaderWrapper>
        <BackButtonContainer onClick={onCancel}>
          <LeftArrowIcon />
        </BackButtonContainer>
        <TitleWrapper>
          <Title>
            <FormattedMessage id="DropOffFilter.title" />
          </Title>
        </TitleWrapper>
      </HeaderWrapper>

      <ButtonsContainer>
        <GreyButton type="button" onClick={onSelectAll}>
          <FormattedMessage id="DropOffFilter.button.selectAll" />
        </GreyButton>
        <GreyButton type="button" onClick={onUnselectAll}>
          <FormattedMessage id="DropOffFilter.button.unselectAll" />
        </GreyButton>
      </ButtonsContainer>
      <WasteTypeGrid onSelect={onSelect} selectedWasteTypes={selectedWasteTypes} wasteTypes={wasteTypes} />
      <ButtonsContainer>
        <CancelButton type="button" onClick={onCancel}>
          <FormattedMessage id="DropOffFilter.button.cancel" />
        </CancelButton>
        <ConfirmButton type="button" onClick={onValidate}>
          <FormattedMessage id="DropOffFilter.button.validate" />
        </ConfirmButton>
      </ButtonsContainer>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 40vh;
  max-height: 80vh;
`

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  align-items: center;
`

const TitleWrapper = styled.div`
  flex: 1;
`

const Title = styled.h1`
  margin: auto;
  font-weight: 400;
  font-size: ${({ theme }) => theme.size.large};
  text-align: center;
  max-width: 220px;
`

const BackButtonContainer = styled.button`
  cursor: pointer;
`

const GreyButton = styled(Button)`
  width: 140px;
  color: ${({ theme }) => theme.color.black};
  font-size: ${({ theme }) => theme.size.smaller};
  background-color: ${({ theme }) => theme.color.lightGrey};
`

const CancelButton = styled(GreyButton)`
  font-family: ${({ theme }) => theme.font.semi};
  font-weight: ${({ theme }) => theme.weight.semi};
  font-size: ${({ theme }) => theme.size.small};
`

const ConfirmButton = styled(CancelButton)`
  background-color: ${({ theme }) => theme.color.primary};
  color: ${({ theme }) => theme.color.secondary};
`

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  height: fit-content;
  width: 100%;
`

export default WasteTypeFilterModal
